import { render } from "./ChangeSharedFSServiceOffering.vue?vue&type=template&id=0598efae&scoped=true"
import script from "./ChangeSharedFSServiceOffering.vue?vue&type=script&lang=js"
export * from "./ChangeSharedFSServiceOffering.vue?vue&type=script&lang=js"

import "./ChangeSharedFSServiceOffering.vue?vue&type=style&index=0&id=0598efae&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0598efae"]])

export default __exports__